/**
 * Content module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';

import Builder from '@src/Content/Pages/Builder/Builder.vue';
import BuilderV2Lite from '@src/Content/Pages/BuilderV2/BuilderV2Lite.vue';
import BlockContentSelector from '@src/Content/Pages/Blocks/BlockContentSelector.vue';
import PageBlockEditorWidget from '@src/Content/Pages/Blocks/PageBlockEditorWidget.vue';
import ContentBuilderTypesButton from '@src/Content/Pages/Builder/Types/Button.vue';
import ContentBuilderTypesCSS from '@src/Content/Pages/Builder/Types/CSS.vue';
import ContentBuilderTypesImage from '@src/Content/Pages/Builder/Types/Image.vue';
import ContentBuilderTypesHeadline from '@src/Content/Pages/Builder/Types/Headline.vue';
import ContentBuilderTypesHTML from '@src/Content/Pages/Builder/Types/HTML.vue';
import ContentBuilderTypesPlainText from '@src/Content/Pages/Builder/Types/PlainText.vue';
import ContentBuilderTypesText from '@src/Content/Pages/Builder/Types/Text.vue';
import ContentBuilderTypesTable from '@src/Content/Pages/Builder/Types/Table.vue';

export const setup = (app: App<Element>): void => {
    app.component('Builder', Builder);
    app.component('BuilderLite', BuilderV2Lite);
    app.component('BlockContentSelector', BlockContentSelector);
    app.component('PageBlockEditorWidget', PageBlockEditorWidget);
    app.component('ContentBuilderTypesButton', ContentBuilderTypesButton);
    app.component('ContentBuilderTypesCSS', ContentBuilderTypesCSS);
    app.component('ContentBuilderTypesImage', ContentBuilderTypesImage);
    app.component('ContentBuilderTypesHeadline', ContentBuilderTypesHeadline);
    app.component('ContentBuilderTypesHTML', ContentBuilderTypesHTML);
    app.component('ContentBuilderTypesPlainText', ContentBuilderTypesPlainText);
    app.component('ContentBuilderTypesText', ContentBuilderTypesText);
    app.component('ContentBuilderTypesTable', ContentBuilderTypesTable);
};
